import type { SvelteURL } from 'svelte/reactivity'
import { doHandle } from './fetchUtils'

/**
 * async GET with AbortSignal
 */
export async function async_get(url: SvelteURL, publishPageError = true, options: RequestInit) {
	// const start = performance.now()
	const signal = options?.signal

	// check if already aborted before starting
	if (signal?.aborted) {
		throw signal.reason ?? new DOMException('Aborted', 'AbortError')
	}

	/* artificial delay for testing */
	// await new Promise<void>((resolve, reject) => {
	// 	const abortHandler = () => {
	// 		clearTimeout(timeout)
	// 		console.log('ABORTED', url)
	// 		reject(signal?.reason ?? new DOMException('Aborted', 'AbortError'))
	// 	}
	// 	const timeout = setTimeout(() => {
	// 		signal?.removeEventListener('abort', abortHandler)
	// 		resolve()
	// 	}, 1000)
	// 	signal?.addEventListener('abort', abortHandler, { once: true })
	// })

	const response = await fetch(url, options)
	// const timeToFetch = Math.round(performance.now() - start)
	// console.log('Time to fetch:', timeToFetch, 'ms')
	return doHandle(publishPageError)(response)
}
